import React, { forwardRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { RootState } from '../../../redux/rootState';

const ComponentMorningReportToPrint = forwardRef<HTMLDivElement>((props, ref) => {
  const { morningReportData } = useSelector((state:RootState) => state.dashboardReducer);

  const [receivedReports, overdueReports] = useMemo(() => {
    const received = morningReportData?.RecordsForMorningReport?.map((item, index) => ({
      id: String(index + 1),
      jobOrder: item?.JobOrder,
      siteName: item?.Site,
      analyst: item?.Initials,
      receiveDate: item?.ReceiveDate,
      customerName: item?.Customer,
      dateSent: item?.DateSent,
      dueDate: item?.DueDate,
      isCompleted: item?.IsCompleted,
    }));
    const overDue = morningReportData?.RecordsForDue?.map((item, index) => ({
      id: String(index + 1),
      jobOrder: item?.JobOrder,
      siteName: item?.Site,
      analyst: item?.Initials,
      receiveDate: item?.ReceiveDate,
      customerName: item?.Customer,
      dateSent: item?.DateSent,
      dueDate: item?.DueDate,
      isCompleted: item?.IsCompleted,
    }));

    return [received, overDue];
  }, [morningReportData]);

  return (
    <div ref={ref} className="printable-content">
      {/* First page */}
      <div className="w100 p40 column_align">
        <p className="heading_text_24 underline direction_heading">Report Log - Received</p>
        <p className="heading_text_20 underline direction_heading">{dayjs().format('MM-DD-YYYY')}</p>

        <div className="row_align morning_report_header">
          <p style={{ width: '20%' }}>Job Order #</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '42%' }}>Site Name</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '12%' }}>Analyst</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '20%' }}>Received Date</p>
        </div>
        {receivedReports?.map((report) => (
          <div className="row_align center_align morning_report_record">
            <p style={{ width: '20%' }}>{report?.jobOrder || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '42%', whiteSpace: 'pre-line' }}>{report?.siteName || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '12%' }}>{report?.analyst || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '20%' }}>{report?.receiveDate || ' '}</p>
          </div>
        ))}
      </div>
      <div className="page-break" />

      {/* Second page */}
      <div className="w100 p40 column_align">
        <p className="heading_text_24 underline direction_heading">Report Log - Overdue</p>
        <p className="heading_text_20 underline direction_heading">{dayjs().format('MM-DD-YYYY')}</p>

        <div className="row_align morning_report_header">
          <p style={{ width: '14%' }}>Job Order #</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '39%' }}>Site Name</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '12%' }}>Analyst</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '13%' }}>Date Sent</p>
          <p style={{ width: '3%' }}>{' '}</p>
          <p style={{ width: '13%' }}>Due Date</p>
        </div>
        {overdueReports?.map((report) => (
          <div className="row_align center_align morning_report_record">
            <p style={{ width: '14%' }}>{report?.jobOrder || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '39%', whiteSpace: 'pre-line' }}>{report?.siteName || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '12%' }}>{report?.analyst || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '13%' }}>{report?.dateSent || ' '}</p>
            <p style={{ width: '3%' }}>{' '}</p>
            <p style={{ width: '13%' }}>{report?.dueDate || ' '}</p>
          </div>
        ))}
      </div>
    </div>
  );
});

export default ComponentMorningReportToPrint;
